/* MotoEBikes draft: cart-level synchronisation of REVVI fulfilment charges.
   This enhances the draft storefront; it is NOT a checkout validation function. */
(() => {
  const FEE_DELIVERY = 67636279738677;
  const FEE_BUILT = 67636279705909;
  const FEE_IDS = new Set([FEE_DELIVERY,FEE_BUILT]);
  const keyFor = item => (item.properties || {})['_MEB fulfilment group'] || '';
  const isRevvi = item => !FEE_IDS.has(Number(item.variant_id)) &&
    ((item.vendor || '').toUpperCase() === 'REVVI' || (item.handle || '').startsWith('revvi-')) &&
    (item.properties || {})['REVVI delivery or collection'];
  const methodFor = item => String((item.properties || {})['REVVI delivery or collection'] || '').toLowerCase();
  const feeFor = method => method.includes('built collection') ? FEE_BUILT :
    method.includes('boxed uk delivery') ? FEE_DELIVERY : null;
  const root = () => window.Shopify?.routes?.root || '/';
  async function api(path, data){
    const result = await fetch(root()+'cart/'+path+'.js',{
      method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(data)
    });
    const json = await result.json();
    if(!result.ok) throw new Error(json.description || json.message || 'Cart update failed');
    return json;
  }
  async function readCart(){
    const result=await fetch(root()+'cart.js',{credentials:'same-origin',cache:'no-store'});
    if(!result.ok)throw new Error('Could not verify basket');
    return result.json();
  }
  let active=null;
  async function reconcile(){
    if(active)return active;
    active=(async()=>{
      for(let step=0;step<30;step++){
        const cart=await readCart();
        const bikes=cart.items.filter(isRevvi);
        const needs=new Map();
        for(const bike of bikes){
          const method=methodFor(bike);
          const group=keyFor(bike);
          const fee=feeFor(method);
          if(!group)throw new Error('Please remove and add your REVVI again to confirm delivery or collection.');
          if(!fee && !method.includes('boxed collection'))throw new Error('REVVI delivery choice is missing. Please add the bike again.');
          if(fee)needs.set(group,{id:fee,quantity:(needs.get(group)?.quantity||0)+bike.quantity, label:bike.properties['REVVI delivery or collection']});
        }
        const charges=cart.items.filter(item=>FEE_IDS.has(Number(item.variant_id)));
        let changed=false;
        for(const charge of charges){
          const group=keyFor(charge);
          const need=needs.get(group);
          const expected=need&&Number(charge.variant_id)===need.id?need.quantity:0;
          if(expected!==charge.quantity){await api('change',{id:charge.key,quantity:expected});changed=true;break;}
        }
        if(changed)continue;
        for(const [group,need] of needs){
          const charge=charges.find(item=>keyFor(item)===group&&Number(item.variant_id)===need.id);
          if(!charge){
            await api('add',{items:[{id:need.id,quantity:need.quantity,properties:{'_MEB fulfilment group':group,'REVVI delivery or collection':need.label}}]});
            changed=true;break;
          }
        }
        if(!changed)return cart;
      }
      throw new Error('Unable to synchronise REVVI delivery charges. Please contact MotoEBikes.');
    })().finally(()=>{active=null;});
    return active;
  }
  let promptVisible=false;
  function warning(message){
    let el=document.getElementById('meb-fee-verification');
    if(!el){el=document.createElement('div');el.id='meb-fee-verification';el.setAttribute('role','alert');
      el.style.cssText='padding:13px 16px;margin:12px 0;border:1px solid #b74747;border-radius:9px;background:#fff4f4;color:#7c1717;font-size:14px';
      (document.querySelector('main')||document.body).prepend(el);
    }
    el.textContent=message;promptVisible=true;
  }
  async function verify(){
    const before=await readCart();
    await reconcile();
    const after=await readCart();
    if(before.item_count!==after.item_count || before.total_price!==after.total_price){
      location.reload();
      return false;
    }
    return true;
  }
  document.addEventListener('click',async e=>{
    const button=e.target.closest('button[name="checkout"],a[href*="/checkout"],.cart__checkout-button');
    if(!button)return;
    if(button.dataset.mebVerified==='true'){button.dataset.mebVerified='';return;}
    e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
    button.disabled=true;
    try{
      if(!await verify())return;
      if(button.tagName==='A')location.assign(button.href);
      else { button.dataset.mebVerified='true';button.disabled=false;button.click(); }
    }catch(err){warning(err.message||'Please check the REVVI delivery choices in your basket.');button.disabled=false;}
  },true);
  document.addEventListener('DOMContentLoaded',()=>{
    if(document.querySelector('cart-items,cart-drawer-items')){
      reconcile().then(()=>{}).catch(e=>warning(e.message));
    }
  });
  window.MEBRevviCart={reconcile,readCart};
})();